const palette = [
    { bg: '#e0e7ff', icon: '#4f46e5' }, // indigo
    { bg: '#d1fae5', icon: '#059669' }, // emerald
    { bg: '#fef3c7', icon: '#d97706' }, // amber
    { bg: '#ffe4e6', icon: '#e11d48' }, // rose
    { bg: '#ede9fe', icon: '#7c3aed' }, // violet
    { bg: '#cffafe', icon: '#0891b2' }, // cyan
    { bg: '#ffedd5', icon: '#ea580c' }, // orange
    { bg: '#ccfbf1', icon: '#0d9488' }, // teal
];

export function randomColor(seed) {
    const entry = palette[seed % palette.length];
    return {
        bgStyle: `background-color: ${entry.bg}`,
        iconColor: entry.icon,
    };
}
